import dayjs from 'dayjs';

import { EFilters } from 'features/Filters';
import { useFilters } from 'features/Filters/hooks/useFilters';

import 'dayjs/locale/ru';

dayjs.locale('ru');

const filterFormatDate = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

const getEdgeOfDay: (date: dayjs.Dayjs | null, filter?: 'start' | 'end') => string = (date, filter = 'start') => {
	if (!date) {
		return '';
	}
	const filteredDate = {
		start: date.startOf('day'),
		end: date.endOf('day'),
	};
	return filteredDate[filter].utc().format(filterFormatDate);
};

export const useDateFilters = (after: EFilters, before: EFilters) => {
	const { getFilterValue, onFilterChange } = useFilters();

	const valueAfter = getFilterValue(after);
	const valueBefore = getFilterValue(before);

	return {
		dateRange: [
			valueAfter ? dayjs(valueAfter).startOf('day') : null,
			valueBefore ? dayjs(valueBefore).endOf('day') : null,
		] as [start: dayjs.Dayjs | null, end: dayjs.Dayjs | null],
		onDateChange: (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
			const [start, end] = dates || [null, null];
			const [fromDate, toDate] = [getEdgeOfDay(start), getEdgeOfDay(end, 'end')];
			onFilterChange([after, before], null, undefined, [fromDate, toDate]);
		},
	};
};
